import React from 'react';
import { PricingHero } from '../components/pricing/PricingHero';
import { PricingTable } from '../components/pricing/PricingTable';
import { PricingQuestions } from '../components/pricing/PricingQuestions';
import { ServiceFaq } from '../components/ServiceFaq';
import { pricingPageFaqs } from '../data/faqs';
export function Pricing() {
  return <>
      <PricingHero data-id="element-1220" data-mp="3v6ps01bq1pns" />
      <PricingTable data-id="element-1221" data-mp="3r779tdbabson" />
      <ServiceFaq serviceName="Pricing" faqs={pricingPageFaqs} showContact={false} data-id="element-1222" data-mp="3r7qie3f1p4q0" />
      <PricingQuestions data-id="element-1223" data-mp="3m8ds18oytfio" />
    </>;
}